// frontend/src/components/WhyChooseUs.js
import React from 'react';
import './WhyChooseUs.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const WhyChooseUs = () => {
    // The ref will be on the main section, triggering animation when the section itself is visible
    const [sectionRef, isSectionVisible] = useScrollAnimation(0.2); // You can adjust this threshold

    return (
        <section
            className="why-choose-us-section" // No 'show' class here.
            ref={sectionRef} // The ref is still on the main section element.
        >
            {/* This div will now receive the 'show' class for the animation */}
            <div className={`why-choose-us-content-wrapper ${isSectionVisible ? 'show' : ''}`}>
                <div className="why-choose-us-title">
                    <h2>Why Green Pod?</h2>
                </div>
                <div className="features-container">
                    
                    {/* Feature Item 1 */}
                    <div className="feature-item">
                        <div className="feature-icon">
                            <i className="fas fa-leaf"></i>
                        </div>
                        <h3 className="feature-heading">100% Pure Authentic Spices</h3>
                        <p className="feature-description">
                            Sourced directly from the finest farms, ensuring authentic flavor and aroma in every pinch.
                        </p>
                    </div>

                    {/* Feature Item 2: Changed from Lab Tested */}
                    <div className="feature-item">
                        <div className="feature-icon">
                            {/* You might want to change this icon to something like fa-check-circle later */}
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <h3 className="feature-heading">Carefully Selected and Hand Checked</h3>
                        <p className="feature-description">
                            Each batch is carefully inspected and selected to maintain purity, aroma, and authentic flavour.
                        </p>
                    </div>

                    {/* Feature Item 3: Changed from Hygienic Packaging */}
                    <div className="feature-item">
                        <div className="feature-icon">
                            <i className="fas fa-handshake"></i>
                        </div>
                        <h3 className="feature-heading">Rooted in Fair Partnership</h3>
                        <p className="feature-description">
                            We work directly with dedicated farmers in Kerala who cultivate spices with care and tradition.
                        </p>
                    </div>

                    {/* Feature Item 4: Changed from Farm to Table */}
                    <div className="feature-item">
                        <div className="feature-icon">
                            <i className="fas fa-tractor"></i>
                        </div>
                        <h3 className="feature-heading">Direct from Kerala Farmers</h3>
                        <p className="feature-description">
                            We source directly from small-scale farmers, ensuring fair value, freshness, and sustainability.
                        </p>
                    </div>

                </div>
            </div> {/* End of why-choose-us-content-wrapper */}
        </section>
    );
};

export default WhyChooseUs;